<template>
    <main>
      <maintenance-view v-if="isMaintenanceActive('casesAndClaims')" />
        <div v-else class="app-view-container">
            <el-row :gutter="20" type="flex" justify="space-between">
                <el-col class="app-view-title">
                    {{ $t('casesAndClaims.title') }}
                </el-col>
                <el-col :span="12" class="align-right" v-if="embedded">
                  <name-badge
                      v-if="account && account.name && account.number"
                      :account-name="getAccountName()"
                      :is-active="getAccountActive()"
                  />
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                    <search-filter ref="searchFilterList" :embedded="embedded" :account="account"/>
                </el-col>
            </el-row>

            <el-row class="search-summary-container bg-white">
                <el-col>
                  <el-row class="default-section-header custom-header-flex" type="flex" align="middle">
                    <el-col :span="6" class="flex-align-center">
                      <span class="title-label">{{ $t('casesAndClaims.title') }}</span>
                      <el-tooltip effect="dark" :content="$t('common.refresh')" placement="top-start">
                        <el-button
                            @click="handleRefresh"
                            icon="el-icon-refresh"
                            size="mini"
                            class="button-action-default refresh-button-gap">
                        </el-button>
                      </el-tooltip>
                    </el-col>

                    <el-col :span="10" :class="getLabels.length ? 'flex-justify-center' : ''">
                      <template v-if="isInternalUser">
                        <el-col :span="8" v-for="label in getLabels" :key="label" justify="center" align="middle">
                          <span class="amount-text-clean">
                            {{ label }}
                          </span><br/>
                          <span class="amount-text-clean">
                            {{ casesAndClaims.labelData[label] ? $options.filters.rateFilter(casesAndClaims.labelData[label]) : '0.00' }}
                          </span>
                        </el-col>
                      </template>
                    </el-col>

                    <el-col :span="8" class="text-align-end button-group-end">
                      <download-csv v-if="isInternalUser" :file-name="'cases-and-claims.csv'" :dispatch-action="'casesAndClaims/generateCsv'" />
                      <close-claims v-if="isInternalUser" />
                      <add-cases-and-claims :account="account"/>
                    </el-col>
                  </el-row>
                    <el-row class="search-summary">
                        <el-col>
                            <search-summary />
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </main>
</template>

<script>
import { mapGetters } from 'vuex';
import NameBadge from '@/views/customerCenter/customerMasterRecord/components/nameBadge/NameBadge';
import CloseClaims from '@/views/customerCenter/casesAndClaims/components/closeClaims/CloseClaims';
import appConfig from '@/config/app-config';
import MaintenanceView from '@/views/maintenance/index';
import DownloadCsv from '@/components/downloadCsv/DownloadCsv';
import AddCasesAndClaims from './components/addCasesAndClaims/AddCasesAndClaims';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';


export default {
  name: 'CasesAndClaims',
  components: {
    MaintenanceView,
    CloseClaims,
    NameBadge,
    SearchFilter,
    SearchSummary,
    AddCasesAndClaims,
    DownloadCsv
  },
  props: {
    embedded: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    ...mapGetters(['casesAndClaims', 'isInternalUser']),
    getAmountLabel() {
      return this.casesAndClaims.label;
    },
    getTotalAmount() {
      return this.casesAndClaims.amount ? this.casesAndClaims.amount : '0.00';
    },
    getLabels() {
      const labelsObject = this.casesAndClaims.labelData;
      const labels = labelsObject && Object.keys(labelsObject) ? Object.keys(labelsObject) : [];
      labels.sort((a, b) => {
        a = a.toUpperCase();
        b = b.toUpperCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
      return labels;
    },
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilterList.handleSearch();
    },
    getAccountName() {
      return this.account ? `${this.account.name}-${this.account.number}` : '';
    },
    getAccountActive() {
      return this.account ? this.account.active : false;
    },
    isMaintenanceActive(menuKey) {
      if (!menuKey || !appConfig.maintenanceConfig || !appConfig.maintenanceConfig[menuKey]) {
        return false;
      }

      const config = appConfig.maintenanceConfig[menuKey];
      const now = new Date();
      const start = new Date(config.start);
      const end = new Date(config.end);

      return now >= start && now <= end;
    }
  },
};
</script>
<style scoped>
.default-section-header {
  min-height: fit-content;
}
.flex-justify-center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 30%;
}
.button-group-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.button-group-end > * {
  display: inline-flex;
}
/* Contenedor principal para asegurar que todo esté en una sola línea */
.custom-header-flex {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 10px 20px;
  box-sizing: border-box;
}

.flex-align-center {
  display: flex;
  align-items: center;
}

/* Espacio entre el texto "Cases and Claims" y el botón de refresh */
.refresh-button-gap {
  margin-left: 12px !important;
}

/* Estilo del monto: Sin fondo, color azul y centrado verticalmente */
.amount-text-clean {
  font-size: 14px;
  color: #004578;
  font-weight: 600;
  line-height: 28px; /* Debe coincidir con el alto del botón para alinearse */
  display: inline-block;
  vertical-align: middle;
}

.text-align-center {
  text-align: center;
}

.text-align-end {
  text-align: end;
}

.title-label {
  font-weight: bold;
  color: #004578;
}
.align-right {
  justify-content: flex-end; /* Fuerza el contenido al extremo derecho */
  text-align: right;        /* Backup para navegadores antiguos [cite: 17] */
}
</style>
